import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import makeRequest from 'utils/makeRequest';
import InViewObserver from 'components/InViewObserver';
// import { gaWrapper } from 'helpers/analytics';
import classNames from 'classnames';
import { isTablet } from 'utils/common';
import ImageV2 from 'components_v2/common/ImageV2';
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
//import SocialWidget from 'routes/articleshow_v2/components/desktop/SocialSharingWeb/SocialSharingWebLoader';
import s from './Iplwidget.scss';
import ArticleshowInsertSchedule from '../../../../articleshow/components/ArticleshowIPLWidgets/ArticleshowInsertIPLSchedule/ArticleshowInsertScheduleLoadable';
// import NotificationHooksWraper from '../../../../liveblog_v2/components/common/NotificationHooksWraper';
//import { TOI_LIVE_DOMAIN } from '../../../../../constants';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class Iplwidget extends React.Component {
  constructor() {
    super();
    this.state = {
      widgetsData: undefined,
      apiURL: undefined,
      // showIzootoSubBtn: true, {/* commented for CWG */}
    };
  }
  componentDidMount() {
    if (this.props.apiURL) {
      this.setState({
        apiURL: this.props.apiURL,
      });
      // this.refreshData(this.props.apiURL);
    }
    if (typeof window !== 'undefined' && window.navigator) {
      this.checkIzootoEnabled();
    }
  }
  refreshTimer = null;
  refreshData = () => {
    const apiurl = this.state.apiURL || this.props.apiURL;
    if (apiurl) {
      makeRequest
        .get(apiurl)
        .then(data => {
          if (data && data.status === 200 && data.data) {
            this.setState({
              widgetsData: data.data,
            });
          }
        })

        .catch(err => console.error(err));
    }
  };

  checkIzootoEnabled = () => {
    if (
      typeof window !== 'undefined' &&
      window.Notification &&
      window.Notification.permission === 'denied'
    ) {
      // this.setState({ showIzootoSubBtn: false }); {/* commented for CWG */}
    }
    if (
      typeof navigator !== 'undefined' &&
      navigator.serviceWorker &&
      typeof navigator.serviceWorker.getRegistrations === 'function'
    ) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          if (
            registration.active.scriptURL ===
            'https://timesofindia.indiatimes.com/grxsw.cms'
          ) {
            // this.setState({ showIzootoSubBtn: true }); {/* commented for CWG */}
          }
        });
      });
    }
  };

  // subscribeToIzooto = () => {
  //   if (typeof window === 'undefined') {
  //     return;
  //   }
  //   gaWrapper(
  //     'send',
  //     'event',
  //     this.props.gaEventCategory,
  //     this.props.gaWidgetAction,
  //     'click_sub',
  //   );
  //   if (
  //     typeof window !== 'undefined' &&
  //     window.Notification &&
  //     window.Notification.permission === 'granted'
  //   ) {
  //     window._izq.push(['triggerPrompt']);
  //     // this.setState({ showIzootoSubBtn: false }); {/* commented for CWG */}
  //   } else if (typeof window !== 'undefined' && window.Notification) {
  //     window.Notification.requestPermission(() => {
  //       if (window.Notification.permission === 'granted') {
  //         window._izq.push(['triggerPrompt']);
  //         // this.setState({ showIzootoSubBtn: false }); {/* commented for CWG */}
  //       }
  //     });
  //   }
  // };

  render() {
    const { sectionData = { data: [] } } = this.props;
    const sectionDataItems = sectionData.items || sectionData.data;
    const {
      widgetsData = {
        schedule: {},
      },
    } = this.state;
    let featuredCard;
    const listItems = [];
    const orangeCapDetails = [];
    const purpleCapDetails = [];
    const linkDetails = [];
    const pointsTableDetails = [];
    const medalTallypTableDetails = [];
    let pointsTableUrl;
    const categoryPrefix = this.props.isWapView ? 'WAP' : 'WEB';
    const slidesToShow = isTablet() ? 2.02 : 3.03;
    const showArrow = !isTablet();
    // const showWhatsappNativeShareTP = isTablet();

    // const sharePageUrl = `${TOI_LIVE_DOMAIN}${sectionData.link}`;

    // const notificationWidgetData = {
    //   subscribeButtonText: 'Subscribe to get live updates',
    //   frmiplwidget: true,
    // };
    const ImageElement = this.context ? ImageV2 : Image;
    if (Array.isArray(sectionDataItems)) {
      sectionDataItems.map((item = {}) => {
        switch (item.tn) {
          case 'lead_plus_5_list': {
            const items = item.items || item.data;
            if (Array.isArray(items)) {
              items.forEach((i, index) => {
                if (index === 0) {
                  featuredCard = (
                    <div className={`${s.newsItem} ${s.lead}`}>
                      <span />
                      <Link
                        href={i.wu}
                        className={s.newsLink}
                        data-newga={`${
                          this.props.gaWidgetAction
                        }#Story_View/https://timesofindia.indiatimes.com${
                          i.wu
                        }`}
                        target={
                          sectionData.target === '_blank'
                            ? sectionData.target
                            : ''
                        }
                        ga4Data={
                          sectionData?.ga4Type && [
                            {
                              event: 'user_click',
                              type: `${
                                sectionData?.ga4Type ? sectionData?.ga4Type : ''
                              }`,
                              category: 'story_click',
                              story_no: `${index + 1}`,
                              msid: i?.id,
                            },
                          ]
                        }
                      >
                        <figure className={s.image}>
                          <div className={s.content}>
                            <ImageElement
                              src={`https://static.toiimg.com/photo/msid-${
                                i.image.id
                              },width-500,resizemode-4,imgsize-${
                                i.image.version
                              }/${i.image.id}.cms`}
                              alt={i.hl}
                              lazyload
                              placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                            />
                          </div>
                        </figure>
                        <div className={s.details}>
                          <span className={s.title}>{i.hl}</span>
                        </div>
                      </Link>
                    </div>
                  );
                } else {
                  listItems.push(
                    <div className={s.newsItem}>
                      <span />
                      <Link
                        className={s.newsLink}
                        to={i.wu}
                        key={i.id}
                        data-newga={`${
                          this.props.gaWidgetAction
                        }#Story_View/https://timesofindia.indiatimes.com${
                          i.wu
                        }`}
                        target={
                          sectionData.target === '_blank'
                            ? sectionData.target
                            : ''
                        }
                        ga4Data={
                          sectionData?.ga4Type && [
                            {
                              event: 'user_click',
                              type: `${
                                sectionData?.ga4Type ? sectionData?.ga4Type : ''
                              }`,
                              category: 'story_click',
                              story_no: `${index + 1}`,
                              msid: i?.id,
                            },
                          ]
                        }
                      >
                        {i.hl}
                        {i.type === 'photostory' ? (
                          <i className="icon photos" />
                        ) : null}
                        {i.type === 'video' ? (
                          <i className="icon videos" />
                        ) : null}
                      </Link>
                    </div>,
                  );
                }
              });
            }
            break;
          }
          case 'orange_cap_section': {
            const items = item.items || item.data;
            if (Array.isArray(items)) {
              items.forEach(i => {
                orangeCapDetails.push(
                  <div className={`${s.item} ${s.orange}`}>
                    <h3>{i.hl}</h3>
                    <figure className={s.icon}>
                      <ImageElement
                        src={`https://static.toiimg.com/photo/msid-${
                          i.image.id
                        },imgsize-${i.image.version}/${i.image.id}.cms`}
                        alt=""
                        lazyload
                        placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                      />
                    </figure>
                    <h4>{i.playername}</h4>
                    <p>{i.playerteam}</p>
                  </div>,
                );
              });
            }
            return null;
          }

          case 'purple_cap_section': {
            const items = item.items || item.data;
            if (Array.isArray(items)) {
              items.forEach(i => {
                purpleCapDetails.push(
                  <div className={`${s.item} ${s.purple}`}>
                    <h3>Purple Cap</h3>
                    <figure className={s.icon}>
                      <ImageElement
                        src={`https://static.toiimg.com/photo/msid-${
                          i.image.id
                        },imgsize-${i.image.version}/${i.image.id}.cms`}
                        alt=""
                        lazyload
                        placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                      />
                    </figure>
                    <h4>{i.playername}</h4>
                    <p>{i.playerteam}</p>
                  </div>,
                );
              });
            }
            break;
          }

          case 'score_card': {
            const items = item.items || item.data;
            if (Array.isArray(items)) {
              items.forEach(childI => {
                switch (childI.tn) {
                  case 'points_table_details': {
                    pointsTableUrl = childI?.viewMore;
                    if (Array.isArray(childI.points_table_data)) {
                      childI.points_table_data.forEach((ci, index2) => {
                        // if (index2 < 4) {
                        pointsTableDetails.push(
                          <tr>
                            <td>
                              <span className={s.count}>{index2 + 1}</span>
                              <i
                                className={classNames({
                                  [s.teamFlag]: true,
                                  [s.DD]: ci.name === 'dc',
                                  [s.RCB]: ci.name === 'rcb',
                                  [s.MI]: ci.name === 'mi',
                                  [s.PBKS]: ci.name === 'kxip',
                                  [s.KKR]: ci.name === 'kkr',
                                  [s.RR]: ci.name === 'rr',
                                  [s.CSK]: ci.name === 'csk',
                                  [s.SRH]: ci.name === 'srh',
                                  [s.GT]: ci.name === 'gt',
                                  [s.LSG]: ci.name === 'lsg',
                                  [s.MINY]: ci.name === 'miny',
                                  [s.WF]: ci.name === 'wf',
                                  [s.SFU]: ci.name === 'sfu',
                                  [s.SO]: ci.name === 'so',
                                  [s.TSK]: ci.name === 'tsk',
                                  [s.LAKR]: ci.name === 'lakr',
                                  [s.GG]: ci.name === 'gg',
                                  [s.UPW]: ci.name === 'upw',
                                })}
                              />
                              {ci.fullname}
                            </td>
                            <td>{ci.P}</td>
                            <td>{ci.W}</td>
                            <td>{ci.L}</td>
                            <td>{ci.NR}</td>
                            <td>{ci.NRR}</td>
                            <td>{ci.PTS}</td>
                          </tr>,
                        );
                        // }
                      });
                    }
                    break;
                  }
                  case 'olympics_points_table_details': {
                    pointsTableUrl = childI?.viewMore;
                    if (Array.isArray(childI.points_table_data)) {
                      childI.points_table_data.sort((a, b) => {
                        if (a.fullname === 'India') {
                          return -1;
                        } else if (b.fullname === 'India') {
                          return 1;
                        }
                        return 0;
                      });
                      childI.points_table_data.forEach((ci, index2) => {
                        // if (index2 < 4) {
                        medalTallypTableDetails.push(
                          <li key={index2}>
                            <span className={s.rank}>{ci.rank}</span>
                            <span className={s.country} data-id={ci.name}>
                              <i className={`${s.flagName} ${s[ci.name]}`} />
                              {ci.fullname}
                            </span>
                            <span className={s.gold}>{ci.gold}</span>
                            <span className={s.silver}>{ci.silver}</span>
                            <span className={s.bronze}>{ci.bronze}</span>
                            <span className={s.total}>{ci.total}</span>
                          </li>,
                        );
                        // }
                      });
                    }
                    break;
                  }
                  case 'links_details': {
                    if (Array.isArray(childI.footerData)) {
                      childI.footerData.forEach(ci => {
                        linkDetails.push(
                          <Link
                            href={ci.url}
                            className={s.opt_item}
                            data-newga={`${this.props.gaWidgetAction}#click_${
                              ci.name
                            }`}
                            target={
                              sectionData.target === '_blank'
                                ? sectionData.target
                                : ''
                            }
                          >
                            <i
                              className={classNames({
                                [s.icons]: true,
                                [s.schedule]: ci.name === 'schedule',
                                [s.medaltally]: ci.name === 'medal tally',
                                [s.videos]: ci.name === 'videos',
                                [s.photos]: ci.name === 'photos',
                                [s.teams]: ci.name === 'teams',
                                [s.stats]: ci.name === 'stats',
                                [s.news]: ci.name === 'news',
                                [s.india]: ci.name === 'india@paris',
                                [s.standings]: ci.name === 'standings',
                                [s.orangecap]: ci.name === 'orange cap',
                                [s.purplecap]: ci.name === 'purple cap',
                                [s.results]: ci.name === 'results',
                                [s.records]: ci.name === 'records',
                                [s.sports]: ci.name === 'sports',
                                [s.halloffame]: ci.name === 'hall of fame',
                                [s.orangecap]: ci.name === 'Most Runs',
                                [s.purplecap]: ci.name === 'Most Wickets',
                              })}
                            />
                            {ci.name}
                          </Link>,
                        );
                      });
                    }
                    break;
                  }

                  default: {
                    return null;
                  }
                }
                return false;
              });
            }
            break;
          }

          default: {
            return null;
          }
        }
        return null;
      });
    }
    return (
      <InViewObserver
        inViewCallback={() => {
          this.refreshData();
          if (sectionData?.ga4Type) {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: `${sectionData?.ga4Type ? sectionData?.ga4Type : ''}`,
              category: `${
                sectionData?.ga4Category ? sectionData?.ga4Category : ''
              }`,
            });
          }
        }}
        viewMargin="300px 0px 300px 0px"
      >
        <div
          className={`${s.sportsWidget}  iplwidget_ui ${
            sectionData?.ga4Type === 'olympic_widget' ||
            sectionData?.ga4Type === 'paralympics_widget'
              ? s.olympic_widget_hp
              : ''
          } ${sectionData?.ga4Type === 'ipl_widget' ? s.ipl_widget_hp : ''}
          `}
          data-scrollga={this.props.gaEventAction}
        >
          {/* <div className={s.btm_bg} /> */}
          <h2 className={s.social_share_heading}>
            <Link
              to={sectionData.link}
              key={sectionData.id}
              data-newga={`${this.props.gaWidgetAction}#click_lp`}
              target={sectionData.target === '_blank' ? sectionData.target : ''}
              ga4Data={
                sectionData?.ga4Type && [
                  {
                    event: 'user_click',
                    type: `${sectionData?.ga4Type ? sectionData?.ga4Type : ''}`,
                    label: `${sectionData?.name}`,
                    category: 'section_heading_click',
                  },
                ]
              }
            >
              {sectionData.name}
            </Link>
          </h2>
          <div className={`${s.flexbox} ${s.newslist_options}`}>
            <div className={s.newsList}>
              {featuredCard}
              <div className={s.newsItemWrapper}>{listItems}</div>
            </div>
            {linkDetails &&
              linkDetails.length > 0 && (
                <div className={`${s.scr_crd_options}`}>{linkDetails}</div>
              )}
          </div>
          {widgetsData &&
            widgetsData.schedule &&
            widgetsData.schedule.matches && (
              <ArticleshowInsertSchedule
                data={this.state.widgetsData.schedule}
                apiURL={sectionData.path}
                isWapView
                refreshData={this.refreshData}
                refreshTimer={this.refreshTimer}
                categoryPrefix={categoryPrefix}
                slidesToShow={slidesToShow}
                showArrow={showArrow}
                showScheduleLink={false}
                gaEventCategory={this.props.gaEventCategory}
                gaEventAction={this.props.gaWidgetAction}
                ga4Type={sectionData?.ga4Type}
                ga4Category={sectionData?.ga4Category}
              />
            )}
          <div className={`${s.flexbox} ${s.mt15}`}>
            <Link
              to={`https://timesofindia.indiatimes.com${pointsTableUrl}`}
              target="_blank"
              data-ga="WEB-IN-NHP1|IPL_Widget_Actions|click_pointstable"
              className={s.pointsTableContainer}
            >
              {pointsTableDetails &&
                pointsTableDetails.length > 0 && (
                  <table className={s.pointsTable}>
                    {
                      <tr>
                        <th>Team</th>
                        <th>played</th>
                        <th>won</th>
                        <th>lost</th>
                        <th>N/R</th>
                        <th>net RR</th>
                        <th>points</th>
                      </tr>
                    }
                    {pointsTableDetails}
                  </table>
                )}
              {medalTallypTableDetails &&
                medalTallypTableDetails.length > 0 && (
                  <ul className={`${s.pointsTable} ${s.medaltallyTable}`}>
                    {
                      <li>
                        <span className={s.rank}>Rank</span>
                        <span className={s.country}>COUNTRY</span>
                        <span className={s.gold}>
                          <i /> Gold
                        </span>
                        <span className={s.silver}>
                          <i /> Silver
                        </span>
                        <span className={s.bronze}>
                          <i /> Bronze
                        </span>
                        <span className={s.total}>Total</span>
                      </li>
                    }
                    {medalTallypTableDetails}
                  </ul>
                )}
            </Link>
            {orangeCapDetails &&
              orangeCapDetails.length > 0 && (
                <div className={s.topLeaders}>
                  {orangeCapDetails}
                  {purpleCapDetails}
                </div>
              )}
          </div>
        </div>
      </InViewObserver>
    );
  }
}
Iplwidget.contextType = UseIntersectionObeserver;
Iplwidget.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  isWapView: PropTypes.bool,
  // isAppView: PropTypes.bool, {/* commented for CWG */}
  apiURL: PropTypes.string,
  gaEventCategory: PropTypes.string,
  gaEventAction: PropTypes.string,
  gaWidgetAction: PropTypes.string,
};

Iplwidget.defaultProps = {
  isWapView: false,
  // isAppView: false,{/* commented for CWG */}
  apiURL: undefined,
  gaEventCategory: 'WEB-IN-NHP1',
  gaEventAction: 'Scroll_Section_View-IPLStarts',
  gaWidgetAction: 'IPL_Widget_Actions',
};

export default Iplwidget;
